export let Tone = /*#__PURE__*/function (Tone) {
  Tone["default"] = "default";
  Tone["acid"] = "acid";
  Tone["orange"] = "orange";
  Tone["flame"] = "flame";
  Tone["lava"] = "lava";
  Tone["pink"] = "pink";
  Tone["magenta"] = "magenta";
  Tone["purple"] = "purple";
  Tone["indigo"] = "indigo";
  Tone["blue"] = "blue";
  Tone["jellyfish"] = "jellyfish";
  Tone["algae"] = "algae";
  return Tone;
}({});
//# sourceMappingURL=types.js.map